/**
 * RD-SEC-015 — TOTP issuer label shown inside the user's authenticator app.
 *
 * Enrollment used to register the entry under the raw hostname, so people
 * looked for "CrewVex" in their app and couldn't find it (found in the
 * RD-SEC-015 audit, 2026-09-25). A factor enrolled against the PRODUCTION
 * Supabase project gets the clean brand name; every other build (the dev
 * deployment, localhost) gets "CrewVex Dev" so a dev-enrolled factor is
 * visually distinguishable from a real one inside the same authenticator app.
 *
 * RD-OPS-004 (2026-10-10): keyed on the build setting that picks the Supabase
 * project — the same rule as `supabaseConfig.js` / `computeIsDebugBuild` — and
 * never on the address. It used to compare `window.location.hostname` to
 * `service.crewvex.com`, so moving the app to `app.crewvex.com` would have
 * labelled every new prod factor "CrewVex Dev".
 */
import { computeIsDebugBuild } from '../env/debugBuild';

/**
 * @param {string|undefined} [nodeEnv] `process.env.NODE_ENV` (injectable for tests)
 * @param {string|undefined} [supabaseEnv] `process.env.REACT_APP_SUPABASE_ENV`
 * @returns {'CrewVex'|'CrewVex Dev'}
 */
export function mfaTotpIssuer(
  nodeEnv = process.env.NODE_ENV,
  supabaseEnv = process.env.REACT_APP_SUPABASE_ENV,
) {
  return computeIsDebugBuild(nodeEnv, supabaseEnv) ? 'CrewVex Dev' : 'CrewVex';
}

export default mfaTotpIssuer;
